var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ml-2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.768979 11C0.557083 11 0.375946 10.9265 0.225567 10.7796C0.0751891 10.6326 0 10.4532 0 10.2413C0 10.0294 0.0786068 9.84482 0.23582 9.68761L4.37806 5.55563L0.23582 1.42364C0.0786068 1.26643 0 1.08187 0 0.869977C0 0.65808 0.0751891 0.478652 0.225567 0.331692C0.375946 0.184731 0.557083 0.111251 0.768979 0.111251C0.967205 0.111251 1.14492 0.183022 1.30214 0.326565L5.97753 4.98145C6.14158 5.13183 6.22361 5.32322 6.22361 5.55563C6.22361 5.77436 6.14158 5.96575 5.97753 6.1298L1.30214 10.7847C1.1586 10.9282 0.980876 11 0.768979 11Z",
    fill: "#2997FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.776ac2e8c4058a13eaeb2353ffc5d878.svg";
export { ForwardRef as ReactComponent };